import React from 'react';
import PropTypes from 'prop-types';
import { withApi } from '@tencent/react-aio';
import Dialog from '@/components/Dialog';
import MessageBox from '@/components/MessageBox';
import * as ActionTypes from '@/stores/sale/actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import { RadioGroup } from '@tencent/spaui';

class ReleaseLeadModal extends React.Component {
  static propTypes = {
    leadList: PropTypes.arrayOf(PropTypes.object).isRequired,
    onSubmit: PropTypes.func,
  };

  state = {
    reason: '',
    value: null,
  };

  render() {
    const { leadList, cleanReasonConfig } = this.props;
    const { reason, value } = this.state;
    if (_.isEmpty(leadList)) {
      console.error('没有提供待释放的线索列表');
      return null;
    }

    const list = (
      cleanReasonConfig?.reasonFilterList?.CLEANING_STATUS_INVALID || []
    ).map((item) => ({
      label: item.desc,
      value: item.value,
    }));

    return (
      <Dialog
        className="ReleaseLeadModal"
        title="释放线索"
        {...this.props}
        style={{ width: 640 }}
        onSubmit={this.onSubmit}
      >
        <p>您确认需要将所选择的 {leadList.length} 个线索释放到公海吗？</p>
        <p>释放操作后不可取消，线索进入公海后可能会被其他人认领。</p>
        <div style={{ padding: '8px 0' }}>
          <div>
            <span style={{ color: 'red' }}>*</span>请选择原因
          </div>
          <RadioGroup data={list} value={value} onChange={this.handleValue} />
        </div>
        <textarea
          rows={4}
          cols={30}
          className="spaui-input"
          value={reason}
          onChange={this.handleReason}
          placeholder={'释放原因/备注'}
        />
      </Dialog>
    );
  }

  handleReason = (e) => {
    this.setState({ reason: e.target.value });
  };

  handleValue = (e, value) => {
    this.setState({ value });
  };

  onSubmit = () => {
    if (!this.state.value) {
      this.context.error('请选择原因');
      return;
    }
    const releaseLeadsParam = {
      reason: this.state.reason,
      leads: _.map(this.props.leadList, (leadItem) => {
        return {
          leadId: leadItem.leadId,
          version: leadItem.version,
          leadStateReasonTagId: this.state.value, // 线索 leadStateReasonTagId 字段放在 leads 下
        };
      }),
    };

    const { webApi } = this.props;
    webApi
      .releaseLeads()
      .dispatchJson(ActionTypes.RELEASE_LEAD, {
        data: releaseLeadsParam,
      })
      .then(
        (resp) => {
          if (resp.code === 0) {
            this.context.success('释放线索到公海成功');
            this.props.onClose();
            this.props.callback();
          } else {
            this.context.success('释放线索到公海失败', resp.message);
          }
        },
        (error) => {
          this.context.error('释放线索到公海失败', error.message);
        }
      );
  };
}

function mapStateToProps(state) {
  return {
    cleanReasonConfig: state.cleanReasonConfig,
  };
}
export default withApi(connect(mapStateToProps, {})(ReleaseLeadModal));
ReleaseLeadModal.contextType = MessageBox;
